const toggleMenu = () => {
  const toggleBtns = document.querySelectorAll("#menu-mobile-js-toggle");
  const menus = document.querySelectorAll("#menu-mobile-js");
  const closeBtns = document.querySelectorAll(".menu-item--close .close");
  // Exit if elements don't exist

  toggleBtns.forEach((toggleBtn) => {
    if (!toggleBtn || !menus) {
      console.warn("Menu elements not found");
      return;
    }

    const closeMenu = () => {
      toggleBtn.classList.remove("active");
      menus.forEach((menu) => {
        menu.classList.remove("active");
      });
    };

    const openMenu = () => {
      toggleBtn.classList.add("active");
      menus.forEach((menu) => {
        menu.classList.add("active");
      });
    };

    toggleBtn.addEventListener("click", (e) => {
      e.stopPropagation(); // Prevent event bubbling
      if (toggleBtn.classList.contains("active")) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    // Add event listener for close button
    closeBtns.forEach((closeBtn) => {
      if (closeBtn) {
        closeBtn.addEventListener("click", (e) => {
          e.stopPropagation(); // Prevent event bubbling
          closeMenu();
        });
      }
    });

    // Close menu when clicking outside
    document.addEventListener("click", (e) => {
      // Check if menu is open
      menus.forEach((menu) => {
        if (!menu.classList.contains("active")) return;

        // Check if click is outside menu and toggle button
        if (!menu.contains(e.target) && !toggleBtn.contains(e.target)) {
          closeMenu();
        }
      });
    });

    // Prevent menu from closing when clicking inside it
    menus.forEach((menu) => {
      menu.addEventListener("click", (e) => {
        e.stopPropagation();
      });
    });
  });
};

const closeSubmenus = () => {
  const submenus = document.querySelectorAll(".submenu.active");
  const menuItems = document.querySelectorAll(".menu-item.active");

  submenus.forEach((item) => {
    item.classList.remove("active");
  });

  menuItems.forEach((item) => {
    item.classList.remove("active");
  });
};

const closeWhenScroll = () => {
  window.addEventListener("scroll", () => {
    closeSubmenus();
  });
};

const closeSubmenusOnClickOutside = () => {
  document.addEventListener("click", (e) => {
    // Check if any submenu is open
    const activeSubmenus = document.querySelectorAll(".submenu.active");
    if (activeSubmenus.length === 0) return;

    // Check if click is outside all active submenus and their parent menu items
    let clickedInsideAnySubmenu = false;

    activeSubmenus.forEach((submenu) => {
      const parentMenuItem = submenu.closest(".menu-item");
      if (
        submenu.contains(e.target) ||
        (parentMenuItem && parentMenuItem.contains(e.target))
      ) {
        clickedInsideAnySubmenu = true;
      }
    });

    // If click is outside all submenus, close them
    if (!clickedInsideAnySubmenu) {
      closeSubmenus();
    }
  });
};

const initMenu = () => {
  closeWhenScroll();
  closeSubmenusOnClickOutside();
  toggleMenu();
  const menuItems = document.querySelectorAll(".menu-item-drop");

  menuItems.forEach((menuItem) => {
    menuItem.addEventListener("click", async (e) => {
      const link = e.target;

      if (link.getAttribute("href") === "#") {
        e.stopPropagation();
        e.preventDefault();
      }

      const menuItemParent = menuItem.closest(".menu-item");
      const submenu = menuItemParent.querySelector(".submenu");

      if (!submenu) {
        return;
      }

      if (
        submenu.classList.contains("active") &&
        menuItemParent.classList.contains("active")
      ) {
        submenu.classList.remove("active");
        menuItemParent.classList.remove("active");
      } else {
        await closeSubmenus();
        submenu.classList.add("active");
        menuItemParent.classList.add("active");
      }
    });
  });
};

export { initMenu, closeSubmenus };
